import React, { Fragment } from "react";

function Footer() {
  return (
    <Fragment>
      <section className="FooterSection">
        <div className="FooterText">
          Designed in Figma and built with React @ Vince Guo 2023
        </div>
      </section>
    </Fragment>
  );
}

export default Footer;
